import { React, useState, useRef } from "react";
const MarketAnalysisFigure = ({ eventDetails, figuredata }) => {
  return (
    <div style={{ marginTop: "20px", display: "block" }}>
      <div class="tb-content">
        <div class="col-12 row bg-gray-100 market-head">
          <strong style={{ marginLeft: "15px" }} className="site_family">
            {figuredata?.title}
          </strong>
          &nbsp;
          <i class="fa fa-address-book"></i>
        </div>
        <div>
          <div class="card" style={{ padding: "1px 18px" }}>
            <div class="row">
              <div class="col-3 col-lg-4 mobilehide"></div>
              <div
                class="col customcheck"
                style={{ textAlign: "center", border: "1px solid black" }}
              >
                <div id="10">
                  <b>
                    <span class="priceodd">0</span>
                    <br />
                  </b>{" "}
                  <span class="priceamount">8.85</span>
                  <br />
                  <hr style={{ margin: "0px" }} />{" "}
                  <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                    <span class="positioncustom" style={{ color: "red" }}>
                      <strong></strong>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="col customcheck"
                style={{ textAlign: "center", border: "1px solid black" }}
              >
                <div id="1">
                  <b>
                    <span class="priceodd">1</span>
                    <br />
                  </b>{" "}
                  <span class="priceamount">8.85</span>
                  <br />
                  <hr style={{ margin: "0px" }} />{" "}
                  <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                    <span class="positioncustom" style={{ color: "red" }}>
                      <strong></strong>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="col customcheck"
                style={{ textAlign: "center", border: "1px solid black" }}
              >
                <div id="2">
                  <b>
                    <span class="priceodd">2</span>
                    <br />
                  </b>{" "}
                  <span class="priceamount">8.85</span>
                  <br />
                  <hr style={{ margin: "0px" }} />{" "}
                  <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                    <span class="positioncustom" style={{ color: "red" }}>
                      <strong></strong>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="col customcheck"
                style={{ textAlign: "center", border: "1px solid black" }}
              >
                <div id="3">
                  <b>
                    <span class="priceodd">3</span>
                    <br />
                  </b>{" "}
                  <span class="priceamount">8.85</span>
                  <br />
                  <hr style={{ margin: "0px" }} />{" "}
                  <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                    <span class="positioncustom" style={{ color: "red" }}>
                      <strong></strong>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="col customcheck"
                style={{ textAlign: "center", border: "1px solid black" }}
              >
                <div id="4">
                  <b>
                    <span class="priceodd">4</span>
                    <br />
                  </b>{" "}
                  <span class="priceamount">8.85</span>
                  <br />
                  <hr style={{ margin: "0px" }} />{" "}
                  <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                    <span class="positioncustom" style={{ color: "red" }}>
                      <strong></strong>
                    </span>
                  </div>
                </div>
              </div>{" "}
              <div class="col-3 col-lg-4 mobilehide"></div>
            </div>{" "}
            <div class="row">
              <div class="col-3 col-lg-4 mobilehide"></div>{" "}
              <div
                class="col customcheck"
                style={{ textAlign: "center", border: "1px solid black" }}
              >
                <div id="5">
                  <b>
                    <span class="priceodd">5</span>
                    <br />
                  </b>{" "}
                  <span class="priceamount">8.85</span>
                  <br />
                  <hr style={{ margin: "0px" }} />{" "}
                  <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                    <span class="positioncustom" style={{ color: "red" }}>
                      <strong></strong>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="col customcheck"
                style={{ textAlign: "center", border: "1px solid black" }}
              >
                <div id="6">
                  <b>
                    <span class="priceodd">6</span>
                    <br />
                  </b>{" "}
                  <span class="priceamount">8.85</span>
                  <br />
                  <hr style={{ margin: "0px" }} />{" "}
                  <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                    <span class="positioncustom" style={{ color: "red" }}>
                      <strong></strong>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="col customcheck"
                style={{ textAlign: "center", border: "1px solid black" }}
              >
                <div id="7">
                  <b>
                    <span class="priceodd">7</span>
                    <br />
                  </b>{" "}
                  <span class="priceamount">8.85</span>
                  <br />
                  <hr style={{ margin: "0px" }} />{" "}
                  <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                    <span class="positioncustom" style={{ color: "red" }}>
                      <strong></strong>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="col customcheck"
                style={{ textAlign: "center", border: "1px solid black" }}
              >
                <div id="8">
                  <b>
                    <span class="priceodd">8</span>
                    <br />
                  </b>{" "}
                  <span class="priceamount">8.85</span>
                  <br />
                  <hr style={{ margin: "0px" }} />{" "}
                  <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                    <span class="positioncustom" style={{ color: "red" }}>
                      <strong></strong>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="col customcheck"
                style={{ textAlign: "center", border: "1px solid black" }}
              >
                <div id="9">
                  <b>
                    <span class="priceodd">9</span>
                    <br />
                  </b>{" "}
                  <span class="priceamount">8.85</span>
                  <br />
                  <hr style={{ margin: "0px" }} />{" "}
                  <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                    <span class="positioncustom" style={{ color: "red" }}>
                      <strong></strong>
                    </span>
                  </div>
                </div>
              </div>{" "}
              <div class="col-3 col-lg-4 mobilehide"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketAnalysisFigure;